var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9565 12.5H25C25 11.3718 24.8496 10.2788 24.5694 9.23911H11.9565V12.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9565 5.97827H23.1653C22.4001 4.72963 21.4218 3.62597 20.2811 2.71738H11.9565V5.97827Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C15.4418 25 18.1458 23.9832 20.281 22.2826H4.71893C6.85419 23.9832 9.55814 25 12.5 25Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83466 19.0217H23.1653C23.7796 18.0193 24.256 16.9236 24.5694 15.7608H0.430603C0.743933 16.9236 1.22035 18.0193 1.83466 19.0217Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79023 1.95205H6.92935L5.86978 2.72183L6.27451 3.96738L5.21499 3.19761L4.15547 3.96738L4.50508 2.89136C3.57217 3.66846 2.75449 4.57891 2.08066 5.59336H2.44565L1.77119 6.08335C1.66611 6.25864 1.56533 6.43672 1.46875 6.61743L1.79082 7.60869L1.18994 7.17212C1.04058 7.48857 0.903955 7.81216 0.781152 8.14248L1.13599 9.23467H2.44565L1.38608 10.0044L1.79082 11.25L0.731299 10.4802L0.0966309 10.9414C0.0331055 11.452 0 11.9721 0 12.5H12.5C12.5 5.59648 12.5 4.78262 12.5 0C10.0307 0 7.72876 0.716309 5.79023 1.95205ZM6.27451 11.25L5.21499 10.4802L4.15547 11.25L4.5602 10.0044L3.50063 9.23467H4.8103L5.21499 7.98911L5.61968 9.23467H6.92935L5.86978 10.0044L6.27451 11.25ZM5.86978 6.36313L6.27451 7.60869L5.21499 6.83892L4.15547 7.60869L4.5602 6.36313L3.50063 5.59336H4.8103L5.21499 4.3478L5.61968 5.59336H6.92935L5.86978 6.36313ZM10.7582 11.25L9.69868 10.4802L8.63916 11.25L9.0439 10.0044L7.98433 9.23467H9.29399L9.69868 7.98911L10.1034 9.23467H11.413L10.3535 10.0044L10.7582 11.25ZM10.3535 6.36313L10.7582 7.60869L9.69868 6.83892L8.63916 7.60869L9.0439 6.36313L7.98433 5.59336H9.29399L9.69868 4.3478L10.1034 5.59336H11.413L10.3535 6.36313ZM10.3535 2.72183L10.7582 3.96738L9.69868 3.19761L8.63916 3.96738L9.0439 2.72183L7.98433 1.95205H9.29399L9.69868 0.706494L10.1034 1.95205H11.413L10.3535 2.72183Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.9caad1bbefd09ae8d8e91ce6faa838cf.svg";
export { ForwardRef as ReactComponent };